import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Chart } from 'chart.js';
import { CallProcessService } from '../../shared/services/graphics/call-process.service';
import { CallProcess, CallProcessDur, CallProcessError } from '../../shared/models/graphics/call-process';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Router, ActivatedRoute } from '@angular/router';
import { rsltTypeInTitle } from 'src/app/shared/functions/title';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-call-process',
  templateUrl: './call-process.component.html',
  styleUrls: ['./call-process.component.scss', '../analysis/analysis.component.scss',
    '../../../../lib/dt-toolbar/dt-toolbar.component.css',
    '../../../../lib/styles/icons.css',
    '../../../../lib/styles/context-menu.css',
    '../../../../lib/styles/list-menu.css'],
  providers: [CallProcessService]
})
export class CallProcessComponent implements OnInit, OnDestroy {
  clearAllFiltersAction: boolean = true;
  actionsMessage: string = 'Actions';
  modifyFiltersMessage: string = 'Modify filters';
  clearFiltersMessage: string = 'Clear all filters';
  isFilters: boolean = true;
  hasFilters: boolean;

  rsltType: string = "nettest";

  rsltTypeTS = '-1';
  TSSelected: number;

  AutoRefreshInfo: any;

  title: string = "NetTest Graphics";
  staticScreen = false;
  @Output() childTitleEvent = new EventEmitter();

  isLoading = true;

  //https://medium.com/codingthesmartway-com-blog/angular-chart-js-with-ng2-charts-e21c8262777f
  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartType = 'bar';
  public barChartLegend = true;

  public barChartLabels = ["01-22-2019", "01-21-2019", "01-23-2019", "01-24-2019"];//X-Axis
  public barChartData = [//Y-axis
    { data: [10, 58, 17, 7], label: 'SUCCESS' },
    { data: [0, 2, 0, 2], label: 'FAILED' }//,
    //{ data: [12, 34, 20, 9, 49, 15, 45], label: 'Series C' }
  ];

  public barChartLabels1: string[];
  //https://stackoverflow.com/questions/39407618/angular-2-declaring-an-array-of-objects
  public barChartData1: Array<{ data: number[], label: string }> = [
    { data: [0], label: 'SUCCESS' },
    { data: [0], label: 'FAILURE' }
  ];
  public barChartLabels2: string[];
  public barChartData2: Array<{ data: number[], label: string }> = [
    { data: [0], label: 'SUCCESS' },
    { data: [0], label: 'FAILURE' }
  ];
  public barChartLabels3: string[];
  public barChartData3: Array<{ data: number[], label: string }> = [
    { data: [0], label: '0-30Sec' },
    { data: [0], label: '30Sec-2Min' },
    { data: [0], label: '2-10Min' },
    { data: [0], label: '10-30Min' },
    { data: [0], label: 'More than 30Min' }
  ];
  public barChartLabels4: string[];
  public barChartData4: Array<{ data: number[], label: string }> = [
    { data: [0], label: '0-30Sec' },
    { data: [0], label: '30Sec-2Min' },
    { data: [0], label: '2-10Min' },
    { data: [0], label: '10-30Min' },
    { data: [0], label: 'More than 30Min' }
  ];
  public barChartLabels5: string[];
  public barChartData5: Array<{ data: number[], label: string }> = [
    { data: [0], label: 'ERRORS' }
  ];

  interval;
  private subscriptions: Subscription[] = [];
  filterEventIDSelected = false;
  delColSelected = false;
  columnName = "VQuad_Timestamp";
  TimestampType = 1;
  constructor(private _Activatedroute: ActivatedRoute, private _router: Router, private callProcessService: CallProcessService, private commonFilterService: CommonFilterService, private cdr: ChangeDetectorRef) {
    _Activatedroute.params.subscribe(val => {
      this.rsltType = _Activatedroute.snapshot.url[1].path;

      this.setRsltType();
    }); 
    this.commonFilterService.setNonFiltersScreen(this.staticScreen);

    this.commonFilterService.TSType.subscribe(res => {//TsType
      this.TimestampType = res;
      if (this.TimestampType >= 2)//
        this.TimestampType = 1;//Change VQT to VQuad Timestamp if screen doesn't belongs to VQT types nd send as TSTYpe in filtering - IMP
      this.columnName = "VQuad_Timestamp";
      if (this.TimestampType == 2) {
        this.columnName = "VQT_Timestamp";
      }
      else if (this.TimestampType == 0) {
        this.columnName = "Call_Timestamp";
      }
    });

    const _broadSublisten = this.commonFilterService.listen.subscribe(res => {
      //console.log('listen')
      if (res === 'onlyCallGrphInit' && !this.filterEventIDSelected)
        this.createAllBarGraphs('');

      if (this.filterEventIDSelected)
        this.filterEventIDSelected = false;
    });
    this.subscriptions.push(_broadSublisten);

    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });
    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('refresh')
        this.createAllBarGraphs('');
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        //console.log('del')
        if (res !== '') { //IMP IMP
          this.createAllBarGraphs(res);
        }
      });
    this.subscriptions.push(_broadSubDeleteFilter);

    const _broadSubAllGeneralFilter = this.commonFilterService.AllGeneralFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        //console.log('AllGeneralFilter')
        this.AllGeneralFilter = res;
        if (!this.delColSelected && !this.clearAllFiltersBool && this.AllGeneralFilter.length > 0)
          this.createAllBarGraphs('');

        //reset here
        if (this.delColSelected)
          this.delColSelected = false;
        if (this.clearAllFiltersBool)
          this.clearAllFiltersBool = false;
      }
    );
    this.subscriptions.push(_broadSubAllGeneralFilter);

    //const _broadSubGeneralDFFilter = this.commonFilterService.GeneralFilterDF.subscribe(res => {
    //  //console.log('GeneralDFFilter')
    //  this.filters = res;
    //});
    //this.subscriptions.push(_broadSubGeneralDFFilter);
    const _broadSubGeneralFilter = this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log('GeneralFilter')
      //console.log(res)
      this.filters = res;
    });
    this.subscriptions.push(_broadSubGeneralFilter);

    const _broadSubEventIDFilter = this.commonFilterService.GeneralEventIDFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        //console.log('filtersWithEventID')
        //this.filterEventIDSelected = true;
        this.filtersWithEventID = res;
        //if (!this.delColSelected && !this.clearAllFiltersBool && (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0))
        //  this.createAllBarGraphs('');
      });
    this.subscriptions.push(_broadSubEventIDFilter);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(this.AutoRefreshInfo);

        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            this.createAllBarGraphs('');
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);
  }

  setRsltType() {
    this.title = rsltTypeInTitle(this.rsltType);
    this.childTitleEvent.emit(this.title);
  }

  resetBarGraphs(barType) {
    switch (barType) {
      case 1:
        this.barChartData1 = [
          { data: [0], label: "SUCCESS" },
          { data: [0], label: "FAILURE" }
        ];
        break;
      case 2:
        this.barChartData2 = [
          { data: [0], label: "SUCCESS" },
          { data: [0], label: "FAILURE" }
        ];
        break;
      case 3:
        this.barChartData3 = [
          { data: [0], label: "0-30Sec" },
          { data: [0], label: "30Sec-2Min" },
          { data: [0], label: "2-10Min" },
          { data: [0], label: "10-30Min" },
          { data: [0], label: "More than 30Min" }
        ];
        break;
      case 4:
        this.barChartData4 = [
          { data: [0], label: "0-30Sec" },
          { data: [0], label: "30Sec-2Min" },
          { data: [0], label: "2-10Min" },
          { data: [0], label: "10-30Min" },
          { data: [0], label: "More than 30Min" }
        ];
        break;
      case 5:
        this.barChartData5 = [
          { data: [0], label: "ERRORS" }
        ];
        break;
    }
  }

  ngOnInit() {

    //this.hasFilters = this.table.dataFilter.hasFilters();
    if (this.barGraph1 != null)
      this.barGraph1.destroy();
    if (this.barGraph2 != null)
      this.barGraph2.destroy();
    if (this.barGraph3 != null)
      this.barGraph3.destroy();
    if (this.barGraph4 != null)
      this.barGraph4.destroy();
    if (this.barGraph5 != null)
      this.barGraph5.destroy();
    //this.createAllBarGraphs();
    //setTimeout(() => {
    //  this.createAllBarGraphs();
    //}, 500)
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  parentRef(TSSelected) {
    this.TSSelected = parseInt(TSSelected);
    //this.setRsltType();
  }
  parentEventID() {
    this.createAllBarGraphs('');
  }
  parentAutoRef(AutoRefreshInfo) {
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }

  modifyFilter() {
    //this._router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);
    let selectedMainFilterCrieriaName = 'null';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);
    this._router.navigate([{ outlets: { filterPopup: ['filters', selectedMainFilterCrieriaName], configPopup: null } }]);

    /////// when calling modify search set mainfilter to initial values
    //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
    //this.commonFilterService.setMFCustDT("");
    //this.commonFilterService.setMFTZON(0);
    ////this.commonFilterService.basicRefresh();
  }

  clearAllFiltersBool = false;
  clearAllFilters() {
    debugger;
    //console.log('clearAllFilters')
    this.createAllBarGraphs('clearAllFilters');
    //this.table.sorter.sortMeta = [];
    //this.table.events.onSort();//IMP- to reset sorting sel cols to none

    //if (this.table.dataFilter.hasFilters()) {
    //  this.table.dataFilter.clear();
    //  //console.log(this.table.dataFilter.hasFilters())
    //  this.table.events.onFilter();
    //  //this.table.events.onFilterClear();
    //  this.clearFilters.emit();
    //}
  }

  createBarGraph() {
    new Chart((<HTMLCanvasElement>document.getElementById('dash-bar-graph')).getContext("2d"), {
      type: 'bar',
      data: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
        datasets: [
          {
            backgroundColor: 'rgba(92, 107, 192, .7)',
            borderColor: 'rgba(92, 107, 192, .7)',
            data: [70, 88, 77, 93, 82, 100, 70, 67, 78, 99],
            label: 'Dataset',
            fill: 'false'
          },
          {
            backgroundColor: 'rgba(66, 165, 245, .7)',
            borderColor: 'rgba(69, 39, 160, .7)',
            data: [80, 88, 67, 95, 76, 60, 67, 95, 95, 66],
            label: 'Dataset',
            fill: 'false'
          },
          {
            backgroundColor: 'rgba(38, 166, 154, .7)',
            borderColor: 'rgba(69, 39, 160, .7)',
            data: [60, 88, 70, 67, 27, 83, 78, 88, 95, 60],
            label: 'Dataset',
            fill: 'false'
          },
          {
            backgroundColor: 'rgba(102, 187, 106, .7)',
            borderColor: 'rgba(255, 99, 132)',
            data: [75, 55, 55, 95, 66, 88, 70, 78, 77, 100],
            label: 'Dataset',
            fill: 'false'
          }
        ]
      },
      options: {
        legend: {
          display: false
        },
        elements: {
          line: {
            tension: 0.000001
          }
        },
        maintainAspectRatio: false,
        plugins: {
          filler: {
            propagate: false
          }
        },
        title: {
          display: true,
          text: 'SALES GRAPH'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            }
          }]
        }
      }
    })
  }

  myColors = [
    {
      backgroundColor: 'rgba(103, 58, 183, .1)',
      borderColor: 'rgb(103, 58, 183)',
      pointBackgroundColor: 'rgb(103, 58, 183)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(103, 58, 183, .8)'
    },
    // ...colors for additional data sets
  ];

  //chartData = [];
  //chartLabels = [];
  refreshFunc() {
    //console.log(this.TSBetween + " ngOnInit");

    //this.barChartData1 = [];
    //this.barChartData2 = [];
    //this.barChartData3 = [];
    //this.barChartData4 = [];
    //this.barChartData5 = [];

    this.callProcessService.getCallProcessesList('', this.AllGeneralFilter, this.filtersWithEventID, this.filters, this.TimestampType, this.columnName).then(responseList => {
      let callProcess: CallProcess[] = <CallProcess[]>responseList[0];
      if (callProcess[0].VQuadNewTS != undefined) {
        if (callProcess[0].VQuadNewTS.trim().length != 0) {
          this.barChartData1 = [];
          this.barChartLabels1 = [];
          //https://www.tutorialspoint.com/typescript/typescript_array_map.htm
          //https://stackoverflow.com/questions/43454752/map-multiple-properties-in-array-of-objects-to-the-same-array
          //https://stackoverflow.com/questions/38698105/what-is-the-equivalent-method-in-angular-2-of-angular-grep-method
          //https://stackoverflow.com/questions/35504310/deep-copy-an-array-in-angular-2-typescript
          //https://googlechrome.github.io/samples/object-assign-es6/
          //callProcess.forEach((dataset, index) => {
          //  this.barChartLabels1[index] = callProcess[index].VQuadNewTS;
          //});
          this.barChartLabels1 = callProcess.map(x => x.VQuadNewTS);
          //this.barChartLabels1 = ["01-25-2019", "01-26-2019", "01-27-2019", "01-28-2019"];//X-Axis

          this.barChartData1.push({ data: callProcess.map(x => x.SUCCESS), label: "SUCCESS" });
          this.barChartData1.push({ data: callProcess.map(x => x.FAILED), label: "FAILED" });
          //this.barChartData1 = [//Y-axis
          //  { data: [50, 58, 17, 7], label: 'SUCCESS' },
          //  { data: [0, 2, 0, 2], label: 'FAILED' }//,
          //  //{ data: [12, 34, 20, 9, 49, 15, 45], label: 'Series C' }
          //];

          //this.chartData.forEach((dataset, index) => {
          //  this.chartData[index] = Object.assign({}, this.barChartData1[index]);
          //});

          //this.chartLabels = [...this.barChartLabels1];
        }
      }
      else
        this.resetBarGraphs(1);

      callProcess = <CallProcess[]>responseList[1];
      if (callProcess[0].VQuadNewTS != undefined) {
        if (callProcess[0].VQuadNewTS.trim().length != 0) {
          this.barChartData2 = [];
          this.barChartLabels2 = callProcess.map(x => x.VQuadNewTS);
          this.barChartData2.push({ data: callProcess.map(x => x.SUCCESS), label: "SUCCESS" });
          this.barChartData2.push({ data: callProcess.map(x => x.FAILED), label: "FAILED" });
        }
      }
      else
        this.resetBarGraphs(2);

      let callProcessDur: CallProcessDur[] = <CallProcessDur[]>responseList[2];
      if (callProcessDur[0].VQuadNewTS != undefined) {
        if (callProcessDur[0].VQuadNewTS.trim().length != 0) {
          this.barChartData3 = [];
          this.barChartLabels3 = callProcessDur.map(x => x.VQuadNewTS);
          this.barChartData3.push({ data: callProcessDur.map(x => x.ThirtySec), label: "0-30Sec" });
          this.barChartData3.push({ data: callProcessDur.map(x => x.TwoMin), label: "30Sec-2Min" });
          this.barChartData3.push({ data: callProcessDur.map(x => x.TenMin), label: "2-10Min" });
          this.barChartData3.push({ data: callProcessDur.map(x => x.ThirtyMin), label: "10-30Min" });
          this.barChartData3.push({ data: callProcessDur.map(x => x.MoreThirtyMin), label: "More than 30Min" });
        }
      }
      else
        this.resetBarGraphs(3);

      callProcessDur = <CallProcessDur[]>responseList[3];
      if (callProcessDur[0].VQuadNewTS != undefined) {
        if (callProcessDur[0].VQuadNewTS.trim().length != 0) {
          this.barChartData4 = [];
          this.barChartLabels4 = callProcessDur.map(x => x.VQuadNewTS);
          this.barChartData4.push({ data: callProcessDur.map(x => x.ThirtySec), label: "0-30Sec" });
          this.barChartData4.push({ data: callProcessDur.map(x => x.TwoMin), label: "30Sec-2Min" });
          this.barChartData4.push({ data: callProcessDur.map(x => x.TenMin), label: "2-10Min" });
          this.barChartData4.push({ data: callProcessDur.map(x => x.ThirtyMin), label: "10-30Min" });
          this.barChartData4.push({ data: callProcessDur.map(x => x.MoreThirtyMin), label: "More than 30Min" });
        }
      }
      else
        this.resetBarGraphs(4);

      let callProcessError: CallProcessError[] = <CallProcessError[]>responseList[4];
      if (callProcessError[0].VQuadNewTS != undefined) {
        if (callProcessError[0].VQuadNewTS.trim().length != 0) {
          this.barChartData5 = [];
          this.barChartLabels5 = callProcessError.map(x => x.VQuadNewTS);
          this.barChartData5.push({ data: callProcessError.map(x => x.ERRORSCOUNT), label: "ERRORS" });
        }
      }
      else
        this.resetBarGraphs(5);
    });
  }

  barGraph1 = null;
  barGraph2 = null;
  barGraph3 = null;
  barGraph4 = null;
  barGraph5 = null;
  AllGeneralFilter = [];
  genArrDel = [];
  filtersWithEventID = {};
  filters = {};
  createAllBarGraphs(delFilterColName) {
    //console.log(this.AllGeneralFilter)
    if (delFilterColName == 'VQuad_CallID') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
    }
    else if (delFilterColName == 'clearAllFilters') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key !== this.columnName)
          delete this.filters[key];
      }
    }
    this.isLoading = true;

    let callProcess: CallProcess[];
    let callProcessHead = "PLACING CALLS";
    let callProcessDur: CallProcessDur[];
    let callProcessDurHead = "PLACING CALLS";
    let callProcessErr: CallProcessError[];
    this.callProcessService.getCallProcessesList(delFilterColName, this.AllGeneralFilter, this.filtersWithEventID, this.filters, this.TimestampType, this.columnName).then(responseList => {
      //console.log(responseList)
      //https://github.com/chartjs/Chart.js/issues/3930
      //https://stackoverflow.com/questions/42788924/chartjs-bar-chart-showing-old-data-when-hovering
      if (this.barGraph1 != null)
        this.barGraph1.destroy();
      if (this.barGraph2 != null)
        this.barGraph2.destroy();
      if (this.barGraph3 != null)
        this.barGraph3.destroy();
      if (this.barGraph4 != null)
        this.barGraph4.destroy();
      if (this.barGraph5 != null)
        this.barGraph5.destroy();

      for (var x = 1; x < 3; x++) {
        if (x == 2)
          callProcessHead = "INCOMING CALLS";
        callProcess = <CallProcess[]>responseList[x - 1];
        if (callProcess[0].VQuadNewTS != undefined) {
          if (callProcess[0].VQuadNewTS.trim().length != 0) {
            let currBarGraph = new Chart((<HTMLCanvasElement>document.getElementById('dash-bar-graph' + x)).getContext("2d"), {
              type: 'bar',
              data: {
                labels: callProcess.map(x => x.VQuadNewTS),
                datasets: [
                  {
                    backgroundColor:'darkgreen', //'rgba(92, 107, 192, .7)',
                    borderColor: 'darkgreen',//'rgba(92, 107, 192, .7)',
                    data: callProcess.map(x => x.SUCCESS),
                    label: 'SUCCESS',
                    fill: 'false'
                  },
                  {
                    backgroundColor: 'red', //'rgba(66, 165, 245, .7)',
                    borderColor: 'red',//'rgba(69, 39, 160, .7)',
                    data: callProcess.map(x => x.FAILED),
                    label: 'FAILURE',
                    fill: 'false'
                  }
                ]
              },
              options: {
                responsive: true,
                legend: {
                  display: true
                },
                elements: {
                  line: {
                    tension: 0.000001
                  }
                },
                maintainAspectRatio: false,
                plugins: {
                  filler: {
                    propagate: false
                  }
                },
                title: {
                  display: true,
                  text: callProcessHead
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                    }
                  }]
                }
              }
            })

            if (x == 1)
              this.barGraph1 = currBarGraph;
            else if (x == 2)
              this.barGraph2 = currBarGraph; 
          }
        }
      }

      for (var x = 3; x < 5; x++) {
        if (x == 4)
          callProcessDurHead = "INCOMING CALLS";
        callProcessDur = <CallProcessDur[]>responseList[x - 1];
        if (callProcessDur[0].VQuadNewTS != undefined) {
          if (callProcessDur[0].VQuadNewTS.trim().length != 0) {
            let currBarGraph = new Chart((<HTMLCanvasElement>document.getElementById('dash-bar-graph' + x)).getContext("2d"), {
              type: 'bar',
              data: {
                labels: callProcessDur.map(x => x.VQuadNewTS),
                datasets: [
                  {
                    backgroundColor:'darkgreen', //'rgba(92, 107, 192, .7)',
                    borderColor:'darkgreen', //'rgba(92, 107, 192, .7)',
                    data: callProcessDur.map(x => x.ThirtySec),
                    label: '0-30Sec',
                    fill: 'false'
                  },
                  {
                    backgroundColor:'indigo', // 'rgba(66, 165, 245, .7)',
                    borderColor: 'indigo',  //'rgba(69, 39, 160, .7)',
                    data: callProcessDur.map(x => x.TwoMin),
                    label: '30Sec-2Min',
                    fill: 'false'
                  },
                  {
                    backgroundColor:'blue', //'rgba(38, 166, 154, .7)',
                    borderColor: 'blue', //'rgba(69, 39, 160, .7)',
                    data: callProcessDur.map(x => x.TenMin),
                    label: '2-10Min',
                    fill: 'false'
                  },
                  {
                    backgroundColor:'black', //'rgba(102, 187, 106, .7)',
                    borderColor: 'black',//'rgba(255, 99, 132)',
                    data: callProcessDur.map(x => x.ThirtyMin),
                    label: '10-30Min',
                    fill: 'false'
                  },
                  {
                    backgroundColor:'red', //'rgba(103, 58, 183, .1)',
                    borderColor:'red', //'rgba(103, 58, 183)',
                    data: callProcessDur.map(x => x.MoreThirtyMin),
                    label: 'More than 30Min',
                    fill: 'false'
                  }
                ]
              },
              options: {
                responsive: true,
                legend: {
                  display: true
                },
                elements: {
                  line: {
                    tension: 0.000001
                  }
                },
                maintainAspectRatio: false,
                plugins: {
                  filler: {
                    propagate: false
                  }
                },
                title: {
                  display: true,
                  text: callProcessDurHead + ' DURATION'
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                    }
                  }]
                }
              }
            })

            if (x == 3)
              this.barGraph3 = currBarGraph;
            else if (x == 4)
              this.barGraph4 = currBarGraph; 
          }
        }
      }

      for (var x = 5; x < 6; x++) {
        callProcessErr = <CallProcessError[]>responseList[x - 1];
        if (callProcessErr[0].VQuadNewTS != undefined) {
          if (callProcessErr[0].VQuadNewTS.trim().length != 0) {
            this.barGraph5 = new Chart((<HTMLCanvasElement>document.getElementById('dash-bar-graph' + x)).getContext("2d"), {
              type: 'bar',
              data: {
                labels: callProcessErr.map(x => x.VQuadNewTS),
                datasets: [
                  {
                    backgroundColor:'red', //'rgba(92, 107, 192, .7)',
                    borderColor:'red',  // 'rgba(92, 107, 192, .7)',
                    data: callProcessErr.map(x => x.ERRORSCOUNT),
                    label: 'ERRORS',
                    fill: 'false'
                  }
                ]
              },
              options: {
                responsive: true,
                legend: {
                  display: true
                },
                elements: {
                  line: {
                    tension: 0.000001
                  }
                },
                maintainAspectRatio: false,
                plugins: {
                  filler: {
                    propagate: false
                  }
                },
                title: {
                  display: true,
                  text: 'ERROR EVENTS'
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                    }
                  }]
                }
              }
            })
          }
        }
      }

      this.hasFilters = responseList[5] <= 0 ? false : true;
    }).catch(error => {
      this.isLoading = false;
    }
    ).finally(() => {
      this.isLoading = false;
      });

    //if (delFilterColName == 'clearAllFilters') {//!=
    //  this.commonFilterService.setClearAllFiltersData();//reset if delete
    //  this.commonFilterService.setGeneralEventIDFilterData({});
    //}
    if (delFilterColName != '' && delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != delFilterColName;
      });
      //console.log(this.genArrDel)
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (delFilterColName == 'clearAllFilters') {
      this.clearAllFiltersBool = true;    

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);
      this.commonFilterService.setGeneralFilterDFData(this.filters);//mainly used in main screen

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    //this.cdr.detectChanges();
  }
}
